import { faqComputadorDaEmpresa, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const secretaria: ProfessionPageConfig = {
  path: '/ia-para-secretaria-e-assistente-administrativo/',
  key: 'secretaria',
  title: 'IA para secretária e assistente administrativo | Oficina IA',
  description:
    'Três tarefas do escritório que a IA adianta no computador: preencher documentos a partir de uma lista, montar a planilha do mês e organizar arquivos.',
  imageAlt: 'Oficina IA: IA para secretária e assistente administrativo',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para secretária e assistente administrativo e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para secretária e assistente administrativo',
  intro:
    'Boa parte do trabalho de escritório é copiar de um lugar e colar em outro: nome por nome, linha por linha. Aqui estão três tarefas desse tipo que a IA pode ajudar a adiantar, sem programar.',
  rogerio: { pose: 'conferindo', text: 'Eu confiro a lista. Você confere o que importa.' },
  tasks: [
    {
      title: 'Documentos preenchidos a partir de uma lista',
      tone: 'sky',
      brings: 'um modelo em branco e a planilha com os nomes.',
      helps: 'preenche um documento para cada pessoa e salva na pasta.',
      continues: 'abre alguns, confere e envia. Na semana seguinte, troca a lista e repete.',
    },
    {
      title: 'A planilha do mês',
      tone: 'peach',
      brings: 'a lista exportada do sistema e a tabela de descontos.',
      helps: 'monta a planilha de cobrança com os valores certos e uma mensagem pronta para cada pessoa.',
      continues: 'confere dois ou três e manda.',
    },
    {
      title: 'Arquivos organizados',
      tone: 'sage',
      brings: 'uma pasta bagunçada com contratos, notas e recibos.',
      helps: 'renomeia, separa por assunto e faz uma lista do que encontrou.',
      continues: 'uma pasta em que qualquer pessoa da equipe acha o que precisa.',
    },
  ],
  steps: {
    do: 'A IA prepara os documentos, a planilha ou a pasta organizada dentro da sua pasta.',
    check: 'Abra dois ou três e compare com a lista. A IA pode se enganar; a decisão é sua.',
    resume: 'No mês seguinte, troque a lista e repita o pedido.',
  },
  faq: [
    faqProgramar,
    faqComputadorDaEmpresa,
    {
      question: 'E se a IA se enganar?',
      answer: 'Ela pode se enganar. Por isso o passo de conferir é seu: você abre o que saiu e compara antes de usar. Nas tarefas desta página, conferir dois ou três leva menos tempo do que fazer todos à mão.',
    },
    {
      question: 'Por onde eu começo?',
      answer: 'Marque a primeira conversa, gratuita, de 30 minutos na minha agenda. Você conta o que faz no computador e sai com um primeiro passo para tentar sozinho. Se quiser continuar, combinamos o acompanhamento individual.',
    },
  ],
  closing: {
    title: 'A parte robótica do trabalho, com alguém do lado.',
    text: 'Traga a lista que você copia à mão, a planilha do mês ou a pasta que ninguém acha.',
    rogerio: 'Eu cuido do novelo. Você cuida do resto.',
  },
}
